import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';
import { getServiceResources } from '../api';
import type { ServiceResources } from '../api/service-resources/model';
import { SERVICE_QUERY_CONFIG, SERVICE_RESOURCES_QUERY_KEY } from './config';

export const useServiceResources = (
  userId: number,
  accountId: number,
  filterByOwnedId = false,
): UseQueryResult<ServiceResources> => {
  return useQuery(
    SERVICE_RESOURCES_QUERY_KEY,
    () => getServiceResources(userId, accountId, filterByOwnedId),
    {
      enabled: !!userId,
      ...SERVICE_QUERY_CONFIG,
    },
  );
};
